
class Config {}

//后台服务端接口
// Config.baseUrl = "http://localhost:80/";
Config.baseUrl = "https://api.xcjn888.com/";

Config.baseApi = Config.baseUrl + "admin/";
Config.httpTimeout = 30000;//30秒超时

//开放能力
Config.openApi = Config.baseUrl + "open/";

//阿里云 图片地址
Config.imgUrlCom = "https://xcjn888.oss-cn-guangzhou.aliyuncs.com/online/ui/com/";
Config.imgUrl = "https://xcjn888.oss-cn-guangzhou.aliyuncs.com/online/ui/back/";
Config.dfImg = Config.imgUrlCom + 'no_data.png';

//后台小程序
Config.wxmpBackUrl = "https://***/";

//处理编译时内存溢出
//npm install -g increase-memory-limit
//increase-memory-limit

//install 保存时清空安装
//npm cache clear --force

//install 有的电脑SSL证书过期需要关闭证书检测
//npm config set strict-ssl false

//cookie 时间（天）
Config.cookie_date = "1";

//每页导出行数
Config.export_limit = 3000;

//缓存页面个数
Config.cache_page_qty = 8;

//富文本需要的插件
Config.editerFx = [
    'head',  // 标题
    'bold',  // 粗体
    'fontSize',  // 字号
    'image',
    'video',
    'italic',  // 斜体
    'underline',  // 下划线
    'list',  // 列表
    'strikeThrough',  // 删除线
    'foreColor',  // 文字颜色
    'justify',  // 对齐方式
    'emoticon',
    'undo',  // 撤销
    'redo'  // 重复
];

//语言选择
Config.langs = [
    {
        key: "zh-CN",
        val: "中文简体"
    },
    {
        key: "zh-TW",
        val: "中文繁體"
    },
    {
        key: "en",
        val: "English"
    },
];

//颜色选项卡预定颜色
Config.picker_colors = [
    '#e54d42',
    '#f37b1d',
    '#6739b6',
    '#0081ff',
    '#37a040',
    '#ffffff',
    '#000000'
];
Config.chart_colors = [
    '#5ab1ef',
    '#fe9900',
    '#758afe',
    '#e54d42',
    '#fa6e86',
    '#2d8cf0',
    '#db6025',
    '#40AE2B',
    '#0067a6',
    '#29b1d9',
    '#f3cd22',
    '#e34836',
    '#44866b'
];

export default Config



// WEBPACK FOOTER //
// ./src/utils/config.js